exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2T8-QUSnWwi13Q{background:transparent;height:100%;display:flex;flex-direction:column;padding:32px;min-width:900px}._8erS7cOdcGGKlg{position:absolute;width:100px}.FMKLJUZAMVUfoi{display:flex;flex-direction:row;align-items:center}.FMKLJUZAMVUfoi>:last-child{margin:auto}._3xDD6kI3h9zVPQ{margin:32px auto}", ""]);

// exports
exports.locals = {
	"moonshot": "_2T8-QUSnWwi13Q",
	"logo": "_8erS7cOdcGGKlg",
	"header": "FMKLJUZAMVUfoi",
	"content": "_3xDD6kI3h9zVPQ"
};